var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82335 7.62066C1.27461 8.38503 1.00024 8.76721 1.00024 9.36661C1.00024 9.96601 1.27461 10.3482 1.82335 11.1126C3.40433 13.3148 6.47331 16.8176 10.0002 16.8176C13.527 16.8176 16.596 13.3148 18.177 11.1126C18.7257 10.3482 19.0001 9.96601 19.0001 9.36661C19.0001 8.76721 18.7257 8.38503 18.177 7.62066C16.596 5.41844 13.527 1.91565 10.0002 1.91565C6.47331 1.91565 3.40432 5.41844 1.82335 7.62066Z",
    stroke: "#FF536D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20605 9.36661C7.20605 10.9098 8.45701 12.1607 10.0002 12.1607C11.5433 12.1607 12.7943 10.9098 12.7943 9.36661C12.7943 7.82347 11.5433 6.5725 10.0002 6.5725C8.45701 6.5725 7.20605 7.82347 7.20605 9.36661Z",
    stroke: "#FF536D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05884 16.5569L4.4812 13.819L15.5209 4.98719L18.9411 2.25101",
    stroke: "#FF536D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b319c41dd10f7002c2783432adbf4819.svg";
export { ForwardRef as ReactComponent };